import React from "react";
import { cn } from "./utils";

export default function TextInput({ className = "", invalid = false, ...props }) {
  return (
    <input
      className={cn(
        "h-9 w-full rounded-sm border bg-white px-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-slate-500",
        invalid ? "border-rose-400" : "border-slate-300",
        className
      )}
      {...props}
    />
  );
}
